"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _documentOffset = _interopRequireDefault(require("document-offset"));

var _createStyled = _interopRequireDefault(require("../../../utils/createStyled"));

var _ownerDocument = _interopRequireDefault(require("../../../utils/ownerDocument"));

var _uniqueId2 = _interopRequireDefault(require("lodash/uniqueId"));

var _renderprops = require("react-spring/renderprops");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n    position: absolute;\n    min-width: 100%;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

/* eslint one-var: "off" */
var List = (0, _renderprops.animated)(_createStyled["default"].div(_templateObject()));
var DEFAULT_CONSTRAINTS = {
  maxHeight: null,
  maxWidth: null,
  top: '100%',
  left: 0,
  bottom: 'auto',
  right: 'auto'
};

var _default =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2["default"])(_default, _React$Component);

  function _default(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, _default);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(_default).call(this, props));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", _objectSpread({}, DEFAULT_CONSTRAINTS, {
      active: false
    }));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_restoreDefaultConstraints", function () {
      _this.setState(_objectSpread({}, DEFAULT_CONSTRAINTS));
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "setPosition", function () {
      if (!_this.root.current.offsetParent || !_this.list.current) {
        return;
      }

      var root = _this.root.current,
          list = _this.list.current,
          _root$offsetParent = root.offsetParent,
          offsetWidth = _root$offsetParent.offsetWidth,
          offsetHeight = _root$offsetParent.offsetHeight,
          rootOffset = list && (0, _documentOffset["default"])(list),
          width = list === null || list === void 0 ? void 0 : list.offsetWidth,
          height = list === null || list === void 0 ? void 0 : list.offsetHeight,
          _this$props = _this.props,
          gapTop = _this$props.gapTop,
          gapLeft = _this$props.gapLeft,
          gapBottom = _this$props.gapBottom,
          gapRight = _this$props.gapRight,
          offsetTop = _this$props.offsetTop,
          offsetBottom = _this$props.offsetBottom,
          offsetLeft = _this$props.offsetLeft,
          offsetRight = _this$props.offsetRight;
      var maxWidth = null,
          maxHeight = null,
          top = 'auto',
          right = 'auto',
          bottom = 'auto',
          left = 'auto';

      if (rootOffset) {
        var availTop = rootOffset.top - offsetHeight - gapTop,
            availBottom = _this.docH - rootOffset.top - gapBottom,
            availLeft = rootOffset.left + offsetWidth - gapLeft,
            // minimal padding + scroll
        availRight = _this.docW - rootOffset.left - gapRight,
            dirTop = "calc(100% + ".concat(offsetTop, "px)"),
            dirBottom = "calc(100% + ".concat(offsetBottom, "px)"),
            dirLeft = offsetLeft,
            dirRight = offsetRight; // вылазит на нижнюю границу документа

        if (availBottom < height) {
          var maxAvailHeight;

          if (availBottom > availTop) {
            top = dirTop;
            maxAvailHeight = availBottom;
          } else {
            bottom = dirBottom;
            maxAvailHeight = availTop;
          } // список не влазит по высоте ни в каком случае


          if (height > maxAvailHeight) {
            maxHeight = maxAvailHeight + 'px';
          }
        } else {
          top = dirTop;
        } // вылазит за правую границу документа


        if (availRight < width) {
          var maxAvailWidth;

          if (availLeft > availRight) {
            right = dirRight;
            maxAvailWidth = availLeft;
          } else {
            left = dirLeft;
            maxAvailWidth = availRight;
          } // по горизонтали не помещается ни в каком случае


          if (width > maxAvailWidth) {
            maxWidth = maxAvailWidth + 'px';
          }
        } else {
          left = dirLeft;
        }
      }

      _this.setState({
        top: top,
        right: right,
        bottom: bottom,
        left: left,
        maxWidth: maxWidth,
        maxHeight: maxHeight
      });
    });
    _this.root = _react["default"].createRef();
    _this.list = _react["default"].createRef();
    _this.id = (0, _uniqueId2["default"])('dropdown_overlay');
    return _this;
  }

  (0, _createClass2["default"])(_default, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.active) {
        this.activate();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var active = this.props.active;

      if (active !== prevProps.active) {
        if (active) {
          this.activate();
        } else {
          this.deactivate();
        }
      }
    }
  }, {
    key: "activate",
    value: function activate() {
      var doc = (0, _ownerDocument["default"])(this.root.current); // save it here, before dropdown is closed and options content are invisible

      this.docH = doc.body.offsetHeight;
      this.docW = doc.body.offsetWidth;
      this.setState({
        active: true
      });
    }
  }, {
    key: "deactivate",
    value: function deactivate() {
      this.setState({
        active: false
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          children = _this$props2.children,
          zIndex = _this$props2.zIndex,
          minWidth = _this$props2.minWidth,
          _this$state = this.state,
          maxHeight = _this$state.maxHeight,
          maxWidth = _this$state.maxWidth,
          left = _this$state.left,
          bottom = _this$state.bottom,
          right = _this$state.right,
          top = _this$state.top,
          active = _this$state.active,
          isTopPosition = bottom === 'auto',
          isLeftPosition = right === 'auto';
      var childrenContent = children;

      if (typeof children === 'function') {
        childrenContent = children(_objectSpread({}, this.props, {
          top: isTopPosition,
          left: isLeftPosition,
          open: active
        }));
      }

      return _react["default"].createElement("div", {
        ref: this.root
      }, _react["default"].createElement(_renderprops.Transition, {
        items: active,
        from: {
          opacity: 0,
          transform: 'scaleY(0)'
        },
        enter: {
          opacity: 1,
          transform: 'scaleY(1)'
        },
        leave: {
          opacity: 0,
          transform: 'scaleY(0)'
        },
        config: {
          duration: 150
        },
        onStart: active ? this.setPosition : null,
        onDestroyed: !active ? this._restoreDefaultConstraints : null,
        "native": true
      }, function (active) {
        return active && function (props) {
          return _react["default"].createElement(List, {
            styles: {
              maxHeight: maxHeight,
              maxWidth: maxWidth,
              top: top,
              right: right,
              left: left,
              bottom: bottom,
              zIndex: zIndex,
              minWidth: minWidth
            },
            style: _objectSpread({}, props, {
              transformOrigin: isTopPosition ? 'left top' : 'left bottom'
            }),
            ref: _this2.list
          }, childrenContent);
        };
      }));
    }
  }]);
  return _default;
}(_react["default"].Component);

exports["default"] = _default;
(0, _defineProperty2["default"])(_default, "propTypes", {
  active: _propTypes["default"].bool.isRequired,
  children: _propTypes["default"].any,
  offsetTop: _propTypes["default"].number,
  offsetRight: _propTypes["default"].number,
  offsetBottom: _propTypes["default"].number,
  offsetLeft: _propTypes["default"].number,
  gapTop: _propTypes["default"].number,
  gapRight: _propTypes["default"].number,
  gapBottom: _propTypes["default"].number,
  gapLeft: _propTypes["default"].number,
  zIndex: _propTypes["default"].number,
  minWidth: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string])
});
(0, _defineProperty2["default"])(_default, "defaultProps", {
  offsetTop: 2,
  offsetRight: 0,
  offsetBottom: 2,
  offsetLeft: 0,
  gapTop: 8,
  gapRight: 24,
  gapBottom: 8,
  gapLeft: 8,
  zIndex: 999
});
(0, _defineProperty2["default"])(_default, "displayName", 'DropDown.Views.ListOverlay');